import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Sparkles, Loader2 } from "lucide-react";
import { formatDateTime } from "@/lib/datetime";
import { Card } from "./AnalyticsParts";

export function AiInsights({ customerId, initial }) {
  const [ins, setIns] = useState(initial);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { const r = await api.post(`/customers/${customerId}/analytics/insights`); setIns(r.data); toast.success("Insights generated"); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not generate insights"); }
    finally { setBusy(false); }
  };
  return (
    <Card title="AI Insights" icon={Sparkles} testid="analytics-ai-insights"
      right={<Button size="sm" variant="outline" onClick={run} disabled={busy} data-testid="analytics-generate-insights">
        {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Sparkles className="w-4 h-4 mr-1" />}{ins ? "Regenerate" : "Generate insights"}</Button>}>
      {!ins ? <p className="text-sm text-slate-400">Press "Generate insights" to get follow-up ideas and likely product interests based only on this customer's recorded activity.</p> : (
        <div className="space-y-4" data-testid="analytics-insights-result">
          <p className="text-sm text-slate-700">{ins.summary}</p>
          {!!ins.follow_ups?.length && <div><h4 className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-1.5">Follow-up opportunities</h4>
            <ul className="space-y-2">{ins.follow_ups.map((f, i) => (
              <li key={i} className="rounded-lg border border-slate-200 p-2.5" data-testid={`analytics-followup-${i}`}>
                <div className="text-sm font-medium text-slate-800">{f.title}</div>
                <div className="text-xs text-slate-600">{f.reason}</div>
                {f.evidence && <div className="text-[11px] text-slate-400 mt-0.5">Based on: {f.evidence}</div>}
              </li>))}</ul></div>}
          {!!ins.product_interests?.length && <div><h4 className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-1.5">Possible product interests</h4>
            <ul className="space-y-1">{ins.product_interests.map((p, i) => (
              <li key={i} className="text-sm text-slate-700" data-testid={`analytics-interest-${i}`}><span className="font-medium">{p.product}</span> <span className="text-xs text-slate-400">— {p.evidence}</span></li>))}</ul></div>}
          <p className="text-[11px] text-slate-400">Generated {formatDateTime(ins.generated_at)} by {ins.generated_by} · AI suggestions, check before acting</p>
        </div>
      )}
    </Card>
  );
}
